const middleware = {}

middleware['cookies'] = require('../middleware/cookies.js')
middleware['cookies'] = middleware['cookies'].default || middleware['cookies']

middleware['metas'] = require('../middleware/metas.js')
middleware['metas'] = middleware['metas'].default || middleware['metas']

export default middleware
